/**
 * OpenAI Realtime voices offered for a voicePipeline=REALTIME bot, ranked for
 * customer support and appointment booking. Mirrors ai-engine's RealtimeVoice
 * enum; the value is sent to gpt-realtime as session.audio.output.voice.
 */
export type RealtimeVoice = 'marin' | 'sage' | 'coral' | 'shimmer' | 'alloy';

export const DEFAULT_REALTIME_VOICE: RealtimeVoice = 'marin';

export interface RealtimeVoiceOption {
  value: RealtimeVoice;
  name: string;
  description: string;
  bestFor: string;
}

export const REALTIME_VOICE_OPTIONS: RealtimeVoiceOption[] = [
  {
    value: 'marin',
    name: 'Marin',
    description: 'Natural, polished, warm, professional',
    bestFor: 'Primary customer support and appointment booking',
  },
  {
    value: 'sage',
    name: 'Sage',
    description: 'Calm, composed, thoughtful',
    bestFor: 'Complex bookings, rescheduling, corrections',
  },
  {
    value: 'coral',
    name: 'Coral',
    description: 'Friendly, warm, approachable',
    bestFor: 'General customer support, friendly dealership calls',
  },
  {
    value: 'shimmer',
    name: 'Shimmer',
    description: 'Pleasant, gentle, softer',
    bestFor: 'Receptionist-style IVR, routine inquiries',
  },
  {
    value: 'alloy',
    name: 'Alloy',
    description: 'Balanced, adaptable, neutral',
    bestFor: 'Generic IVR, fallback voice',
  },
];

export interface RealtimeVoicePreviewResult {
  voice: RealtimeVoice;
  text: string;
  audioBase64: string;
  mime: string;
}
